import { IPortfolioReducer } from '@portfolio/IPortfolioReducer';
import { AnyAction } from 'redux';
import { SET_PORTFOLIO_DATA, SET_COMPANY_DETAILS, SET_ASSETS_DETAILS, SET_TOKEN_PITCHES } from './actionTypes';
import { mapInitialDataToStore, mapCompanyDetailsToStore, mapSpvToStore, mapPitchesToTokenPitches } from './reducer.functions';

const initialState: IPortfolioReducer = {
  companies: [],
};

const reducer = (
  state: IPortfolioReducer = initialState,
  action: AnyAction
): IPortfolioReducer => {
  switch (action.type) {
    case SET_PORTFOLIO_DATA:
      return { ...state, companies: mapInitialDataToStore(action.payload) as any };
    case SET_COMPANY_DETAILS:
      return { ...state, companies: mapCompanyDetailsToStore(state , action.payload) };
    case SET_ASSETS_DETAILS:
      return { ...state, companies: mapSpvToStore(state , action.payload) };
    case SET_TOKEN_PITCHES:
      return { ...state, companies: mapPitchesToTokenPitches(state , action.payload) };
    default:
      return state;
  }
};

export default reducer;
